import { Calculator } from '@dynameat/views/reporting/models';
import * as Sentry from '@sentry/vue';
import { MarginQuery } from '../queries';
import { MARGIN } from '../constants';

export class MarginCalculator extends Calculator {
  kpiType = MARGIN

  constructor(productGuid) {
    super();
    this.productGuid = productGuid;
  }

  async calculateKPI() {
    const marginResponse = await this.executeUncubeQuery(MarginQuery, this.productGuid);
    const marginResults = this.processMargin(marginResponse.data.result[0]);
    const groupResponse = await this.executeUncubeQuery(MarginQuery, null, marginResults.groupOfPricing);
    const groupResults = groupResponse.data.result.map(this.processMargin);
    const props = this.getData(marginResults, groupResults);
    return this.getModelToInstance(props);
  }

  executeUncubeQuery(queryClass, ...args) {
    // eslint-disable-next-line new-cap
    const uncubeQuery = new queryClass(...args);
    return uncubeQuery.execute();
  }

  processMargin(rawResponse) {
    if (rawResponse && rawResponse.length > 0) {
      return {
        margin: (rawResponse[1] - rawResponse[2]) / rawResponse[3],
        groupOfPricing: rawResponse[0]
      };
    }
    Sentry.captureMessage('Margin query was empty');
    return {
      margin: 0,
      groupOfPricing: ''
    };
  }

  getData(marginResults, groupResults) {
    const currentKpi = this.getValueOfKpi(marginResults, groupResults);
    return {
      key: this.productGuid,
      kpi: currentKpi,
      increment: null,
      type: this.kpiType,
    };
  }

  getValueOfKpi(marginResults, groupResults) {
    const avgMargin = groupResults.reduce((acc, current) => acc + current.margin, 0) / groupResults.length;
    // Clamp the result to 2, as it is the maximum in the radar chart.
    return Math.min((marginResults.margin / avgMargin) || 0, 2);
  }
}
